/* =============================================================
   SERGIO SCALI -- add to cart without a page refresh
   Loaded FIRST, from the head, WITHOUT defer:
     <script src="{{ 'duetto-cart.js' | asset_url }}"></script>

   WHY. Add to cart is an ordinary form. Something must catch the
   click, or the browser posts the whole page and loads a new one --
   and a page load closes the cart drawer, because the new page
   starts from scratch. The code that normally catches it runs late:
   on a Duetto page the script is deferred and does not run until
   ~1.6s, and on the shared template the theme binds on jQuery's
   document-ready. The button is on screen from under a second. Any
   click in that gap escapes, and the shopper is thrown to /cart.
   Reported by Sergio 27 Sept on both Duetto and Olivia pages.

   This file closes that gap and nothing else. It listens on the
   document in the CAPTURE phase, so it sees a submit before any
   handler on the form, and it only acts while the page is still
   loading:

       if (document.readyState === 'complete') return;

   Once the page has finished loading, every existing handler works
   exactly as it does today and this file stands aside. That keeps
   the change to the one window where the store is actually broken.
   ============================================================= */
(function () {
  if (window.__scaliAddGuard) return;
  window.__scaliAddGuard = true;

  var busy = false;

  function isAddForm(f) {
    if (!f || f.tagName !== 'FORM') return false;
    return (f.getAttribute('action') || '').indexOf('/cart/add') > -1;
  }

  function copyHtml(doc, sel) {
    var src = doc.querySelector(sel), dst = document.querySelector(sel);
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function drawerOpen() {
    var nav = document.getElementById('site-nav--mobile');
    return !!nav && nav.className.indexOf('show-cart') > -1;
  }

  function openManually() {
    var nav = document.getElementById('site-nav--mobile');
    if (!nav) return;
    var overlay = document.getElementById('site-overlay');
    nav.classList.remove('show-filters', 'show-search');
    nav.classList.add('active', 'show-cart');
    if (overlay) overlay.classList.add('active');
    document.body.classList.add('sidebar-move');
    var bg = document.querySelector('.fixing-scroll-now .site-box-background');
    if (bg) bg.classList.add('sidebar-move');
  }

  /* the handle carries the theme's own open animation */
  function openDrawer() {
    var link = document.querySelector('.site-cart-handle a');
    if (!link) { openManually(); return; }
    link.click();
    window.setTimeout(function () { if (!drawerOpen()) openManually(); }, 600);
  }

  /* The cart is re-read with cache off and a changing query string.
     A plain fetch of /cart can be answered from the browser's own
     cache, and for anyone who has ever looked at an empty basket the
     cached answer IS the empty-cart page -- which is how the drawer
     came to open reading YOUR CART IS EMPTY over a cart with an item
     in it. */
  function readCart() {
    return fetch('/cart?scali=' + Date.now(), {
      headers: { 'Accept': 'text/html' }, cache: 'no-store', credentials: 'same-origin'
    }).then(function (r) { return r.text(); });
  }

  function paint(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    copyHtml(doc, '#site-cart .cart-items');
    copyHtml(doc, '.site-cart-handle .count-holder');
    copyHtml(doc, '#CartTotal');
    copyHtml(doc, '#CartDetails');
    var s = doc.querySelector('#site-cart .cart-holder');
    var d = document.querySelector('#site-cart .cart-holder');
    if (s && d && s.hasAttribute('data-items')) {
      d.setAttribute('data-items', s.getAttribute('data-items'));
    }
    /* the drawer's remove links are the theme's, and the markup just
       replaced lost those bindings */
    if (typeof window.sidebarCartAjaxFunctions === 'function') {
      try { window.sidebarCartAjaxFunctions(); } catch (e) {}
    }
  }

  function looksEmpty() {
    var i = document.querySelector('#site-cart .cart-items');
    return !i || i.children.length === 0;
  }

  document.addEventListener('submit', function (e) {
    if (document.readyState === 'complete') return;
    var form = e.target;
    if (!isAddForm(form)) return;
    if (!window.fetch || !window.DOMParser || !window.FormData) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var btn = form.querySelector('[name="add"]');
    if (btn) btn.setAttribute('aria-busy', 'true');

    var action = (form.getAttribute('action') || '/cart/add').split('?')[0];
    if (action.slice(-3) !== '.js') action += '.js';

    fetch(action, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
      credentials: 'same-origin'
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return readCart(); })
      .then(function (html) {
        paint(html);
        if (!looksEmpty()) return null;
        /* painted empty -- read once more before believing it */
        return new Promise(function (go) { window.setTimeout(go, 400); })
          .then(readCart).then(paint);
      })
      .then(function () { openDrawer(); })
      .catch(function () {
        /* The add itself failed. Do NOT post the form: that is what
           reloads the page. Open the drawer so the shopper sees the
           real state of their cart. */
        openDrawer();
      })
      .then(function () {
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
      });
  }, true);
}());
